/* lazy-video.js — owner hard rule 2026-09-24 (_WEBSITE_KIT/08_SPEED.md "VIDEO ON THE WEBSITE").
   Markup: <video data-lazy-video data-src="<480p mp4>" [data-autoplay] preload="none" muted playsinline loop poster="...">
   No video bytes in the first load: the source is attached only after window load AND when the video is within about one
   screen of view, or on tap. Autoplay loops play only while in view and pause out of view. Safe to include more than once. */
(function () {
  if (window.__lazyVideo) return; window.__lazyVideo = true;
  function attach(v) {
    if (v.dataset.lvReady) return; v.dataset.lvReady = "1";
    v.src = v.dataset.src; v.preload = "metadata"; v.load();   // only the first frame + header until it plays; playback then streams
  }
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function start() {
    var vids = [].slice.call(document.querySelectorAll("video[data-lazy-video]"));
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.addEventListener("click", function () { attach(v); if (v.paused) play(v); else if (!v.hasAttribute("data-autoplay")) v.pause(); });
    });
    if (!("IntersectionObserver" in window)) { vids.forEach(function (v) { attach(v); if (v.hasAttribute("data-autoplay")) play(v); }); return; }
    var near = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { attach(e.target); near.unobserve(e.target); } });
    }, { rootMargin: "100% 0px" });
    var seen = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target; if (!v.hasAttribute("data-autoplay")) return;
        if (e.isIntersecting) { attach(v); play(v); } else if (!v.paused) v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { near.observe(v); seen.observe(v); });
  }
  function later() { (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(start); }
  if (document.readyState === "complete") later(); else window.addEventListener("load", later);
})();
